<template lang="pug">
.box(v-if="hasPreviousPages")
    .box-body.p-b-sm
        div
            button.btn.back-button(type="button", @click="backToPreviousPage")
                i.material-icons arrow_back

            h5._400.text-center.m-0 {{ activeGroup.name }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    computed: {
        ...mapGetters('orderLayout', [
            'hasActiveGroup',
            'activePage',
            'activeGroup',
            'hasPreviousPages',
            'orderLayout',
        ]),
    },

    methods: {
        ...mapActions('orderLayout', ['viewPage', 'backToPreviousPage']),
    },
};
</script>

<style lang="scss" scoped>
.back-button {
    position: absolute;
    top: 10px;
    left: 10px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/order-layout/order-layout-group-navigation.vue